import { FC } from 'react';

import { SignatureStatus } from '../../enums/signature-status.const';
import { MultiSelectFilter, MultiSelectFilterOption } from './multi-select-filter';

const STATUS_OPTIONS: MultiSelectFilterOption<SignatureStatus>[] = [
  { value: SignatureStatus.FULLY_SIGNED, labelKey: 'SIGNATURE_STATUS_FULLY_SIGNED' },
  { value: SignatureStatus.PARTIALLY_SIGNED, labelKey: 'SIGNATURE_STATUS_PARTIALLY_SIGNED' },
  { value: SignatureStatus.SIGNATURE_PENDING, labelKey: 'SIGNATURE_STATUS_SIGNATURE_PENDING' },
  { value: SignatureStatus.DOCUMENT_EXPIRED, labelKey: 'SIGNATURE_STATUS_DOCUMENT_EXPIRED' },
  { value: SignatureStatus.VOIDED, labelKey: 'SIGNATURE_STATUS_VOIDED' },
];

type StatusFilterSelectProps = {
  disabled?: boolean;
  onChange: (value: SignatureStatus[]) => void;
  value: SignatureStatus[];
};

export const StatusFilterSelect: FC<StatusFilterSelectProps> = ({ disabled, onChange, value }) => (
  <MultiSelectFilter
    allOptionLabelKey="FILTER_ALL_STATUSES"
    disabled={disabled}
    onChange={onChange}
    options={STATUS_OPTIONS}
    placeholderKey="FILTER_ALL_STATUSES"
    value={value}
  />
);
